export default __webpack_public_path__ + "static/electrical_motor_w.9f2ed37c81b5e83212254c8585e84765.png";